import axios from "axios";
import { GET_ALL_ROLES_URL } from "../../../_metronic/_helpers/Constants";

export const getAllRolesCall = () => axios.post(`${GET_ALL_ROLES_URL}`);
